"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const List_1 = __importDefault(require("@material-ui/core/List"));
const ListItem_1 = __importDefault(require("@material-ui/core/ListItem"));
const ListItemText_1 = __importDefault(require("@material-ui/core/ListItemText"));
const classnames_1 = __importDefault(require("classnames"));
const prop_types_1 = __importDefault(require("prop-types"));
const nested_menu_item_1 = __importDefault(require("../nested-menu-item/nested-menu-item"));
const popover_1 = __importDefault(require("../popover/popover"));
const tooltip_1 = __importDefault(require("../tooltip/tooltip"));
require("../../styles/components/actions-dropdown-list.less");
const DropDownAction = ({ item, onItemClick }) => (react_1.default.createElement(tooltip_1.default, { title: item.tooltip },
    react_1.default.createElement("div", null,
        react_1.default.createElement(ListItem_1.default, { classes: { root: (0, classnames_1.default)('action-dropdown-item', item.itemClass) }, disabled: !!item.disabled, onClick: onItemClick, button: true },
            item.icon ? react_1.default.createElement("i", { className: (0, classnames_1.default)(item.class, 'fa', { [item.icon]: true }) }) : '',
            item.iconComponent,
            react_1.default.createElement(ListItemText_1.default, { primary: item.name, classes: {
                    root: 'action-dropdown-text-root',
                    primary: `action-dropdown-text-item ${item.class}`,
                } }),
            item.iconComponentEnd),
        item.last && react_1.default.createElement("hr", null))));
function ItemWithClick(props) {
    const { item, closePopover, stopClickPropagation, forceClose } = props;
    const onItemClick = (0, react_1.useCallback)((event) => {
        if (stopClickPropagation) {
            event.stopPropagation();
        }
        if (item.onClick) {
            item.onClick();
        }
        closePopover();
    }, [item, closePopover, stopClickPropagation]);
    if (item.nestedComponent) {
        return (react_1.default.createElement(nested_menu_item_1.default, { label: react_1.default.createElement(DropDownAction, { item: item, onItemClick: onItemClick }), disabled: item.disabled, forceClose: forceClose }, item.nestedComponent));
    }
    return react_1.default.createElement(DropDownAction, { item: item, onItemClick: onItemClick });
}
function ActionsDropdownList(props) {
    const { forceClose: initialForceClose, triggerComponent, options, popoverPlacements, dropdownClass, transformOrigin, fixContainer, stopClickPropagation, onOpen, onClose, shouldDisableOnClickWithCtrlOrShift, backgroundGreyed, triggerClassName, } = props;
    const [forceClose, setForceClose] = (0, react_1.useState)(false);
    const [closeNested, setCloseNested] = (0, react_1.useState)(false);
    const closePopover = (0, react_1.useCallback)(() => {
        setForceClose(true);
        if (onClose) {
            onClose();
        }
    }, [onClose]);
    (0, react_1.useEffect)(() => {
        setForceClose(false);
    }, [forceClose]);
    const handleOnOpen = (0, react_1.useCallback)(() => {
        setCloseNested(false);
        if (onOpen) {
            onOpen();
        }
    }, [onOpen]);
    const handleOnClose = (0, react_1.useCallback)(() => {
        setCloseNested(true);
        if (onClose) {
            onClose();
        }
    }, [onClose]);
    return (react_1.default.createElement("div", { className: "actions-dropdown-list" },
        react_1.default.createElement(popover_1.default, { className: `actions-dropdown-list-popover ${dropdownClass}`, triggerComponent: triggerComponent, fixContainer: fixContainer, onOpen: handleOnOpen, onClose: handleOnClose, triggerClassName: triggerClassName, forceClose: forceClose || initialForceClose, popoverPlacements: popoverPlacements, transformOrigin: transformOrigin, backgroundGreyed: backgroundGreyed, shouldDisableOnClickWithCtrlOrShift: shouldDisableOnClickWithCtrlOrShift },
            react_1.default.createElement(List_1.default, { component: "nav" }, options?.map((option) => (react_1.default.isValidElement(option)
                ? react_1.default.createElement("div", { className: "action-dropdown-item" }, option)
                : (react_1.default.createElement(ItemWithClick, { key: option.id ? option.id : option.name, item: option, closePopover: closePopover, stopClickPropagation: !!stopClickPropagation, forceClose: closeNested }))))))));
}
ActionsDropdownList.defaultProps = {
    forceClose: false,
    triggerClassName: '',
    triggerComponent: react_1.default.createElement("i", { className: "fa fa-ellipsis-v" }),
    options: [],
    popoverPlacements: {
        vertical: 'bottom',
        horizontal: 'center',
    },
    transformOrigin: {
        vertical: 'top',
        horizontal: 'center',
    },
    dropdownClass: '',
    fixContainer: true,
    backgroundGreyed: false,
    stopClickPropagation: false,
    onOpen: undefined,
    onClose: undefined,
    shouldDisableOnClickWithCtrlOrShift: false,
};
ActionsDropdownList.propTypes = {
    forceClose: prop_types_1.default.bool,
    triggerClassName: prop_types_1.default.string,
    triggerComponent: prop_types_1.default.oneOfType([prop_types_1.default.element, prop_types_1.default.string]),
    options: prop_types_1.default.arrayOf(prop_types_1.default.oneOfType([
        prop_types_1.default.shape({
            name: prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.element]),
            icon: prop_types_1.default.string,
            iconComponent: prop_types_1.default.object,
            onClick: prop_types_1.default.func,
            tooltip: prop_types_1.default.string,
            disabled: prop_types_1.default.bool,
        }), prop_types_1.default.element
    ])),
    popoverPlacements: prop_types_1.default.shape({
        vertical: prop_types_1.default.oneOf(['top', 'center', 'bottom']),
        horizontal: prop_types_1.default.oneOf(['left', 'center', 'right']),
    }),
    transformOrigin: prop_types_1.default.shape({
        vertical: prop_types_1.default.oneOf(['top', 'center', 'bottom']),
        horizontal: prop_types_1.default.oneOf(['left', 'center', 'right']),
    }),
    dropdownClass: prop_types_1.default.string,
    backgroundGreyed: prop_types_1.default.bool,
    fixContainer: prop_types_1.default.bool,
    stopClickPropagation: prop_types_1.default.bool,
    onOpen: prop_types_1.default.func,
    onClose: prop_types_1.default.func,
    shouldDisableOnClickWithCtrlOrShift: prop_types_1.default.bool,
};
exports.default = ActionsDropdownList;
//# sourceMappingURL=actions-dropdown-list.js.map